<script setup="">
import { computed, inject } from "vue";

const props = defineProps({
  classes: {
    type: String,
    default: ""
  },
  defaultClass: {
    type: String,
    default: "mt-1.5 text-xs+ text-error"
  },
  message: [Array, String]
});

const twMerge = inject("twMerge");

const errorMessage = computed(() => {
  if (Array.isArray(props.message)) {
    return props.message[0];
  }

  return props.message;
});

const computedClasses = computed(() => twMerge(props.defaultClass, props.classes));
</script>

<template>
  <p v-if="message" :class="computedClasses">・ {{ errorMessage }}</p>
</template>
